import React from 'react'
import {
  Button,
  Dropdown,
  DropdownToggle,
  IconExpandMoreDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { trackBrowseClicked } from '../../events'
import { useNav } from '../../navContext'
import { DropdownContentControlled } from '../DropdownContent'
import { GreaterThanOrEqual, LessThan } from '../Media'
import { MobileDropdown } from '../MobileDropdown'
import classes from './Browse.module.scss'

export const Browse = ({
  children: dropdownContent,
  onClose,
}: {
  children: React.ReactNode
  onClose?(): void
}) => {
  const breakpoint = 'lg'
  const { searchInputWidth, showDropdown, setShowDropdown } = useNav()
  const { t } = useTranslation('@mc/next')

  const browseBtn = (
    <Button
      size='sm'
      kind='secondary'
      className={`mc-mr-sm-2 mc-py-3 ${classes.browseBtn}`}
      onClick={() => {
        trackBrowseClicked()
        setShowDropdown((last) => {
          const newShow = !last
          if (newShow === false) onClose?.()
          return newShow
        })
      }}
    >
      <div id='browse-text'>{t('nav.cta.browse')}</div>
      <IconExpandMoreDefault
        size='sm'
        className={`mc-ml-2 ${showDropdown ? classes.expandIconShow : ''}`}
      />
    </Button>
  )

  return (
    <>
      <LessThan bp={breakpoint}>
        {browseBtn}
        {showDropdown && <MobileDropdown>{dropdownContent}</MobileDropdown>}
      </LessThan>
      <GreaterThanOrEqual bp={breakpoint}>
        <Dropdown ariaControls='nav-browse-drp' placement='bottom-start'>
          <DropdownToggle>{browseBtn}</DropdownToggle>

          <DropdownContentControlled
            show={showDropdown}
            setShow={setShowDropdown}
            style={{ width: searchInputWidth, minWidth: 300 }}
          >
            {dropdownContent}
          </DropdownContentControlled>
        </Dropdown>
      </GreaterThanOrEqual>
    </>
  )
}
